module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity"
  }, [_c('ul', {
    staticClass: "activity-list"
  }, _vm._l((_vm.activityList), function(activity, index) {
    return _c('li', {
      key: index,
      staticClass: "activity-item",
      on: {
        "click": function($event) {
          return _vm.goArticleDeail(activity)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": activity.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content-wrapper"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(activity.title))]), _vm._v(" "), _c('div', {
      staticClass: "activity-info"
    }, [_c('span', {
      class: ['status', {
        'ready': activity.status === '即将开始',
        'running': activity.status === '进行中'
      }]
    }, [_vm._v(_vm._s(activity.status))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v("活动时间：" + _vm._s(activity.time))])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0699a7f1!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/activity.vue
// module id = sotv
// module chunks = 16